import { useEffect, useState } from 'react';

const DEFAULT_INITIAL = 5;
const DEFAULT_STEP = 10;

type Options = {
  /** Сколько строк показать сначала */
  initial?: number;
  /** Сколько добавлять за клик */
  step?: number;
  /** Сброс лимита при смене сортировки/фильтра */
  resetKey?: string | number | boolean | null;
  /** 0-based индекс строки, которую нужно обязательно показать */
  ensureIndex?: number | null;
};

/**
 * Показ длинных списков порциями: сначала `initial`, затем +`step`.
 */
export function useLoadMore(total: number, options: Options = {}) {
  const initial = options.initial ?? DEFAULT_INITIAL;
  const step = options.step ?? DEFAULT_STEP;
  const resetKey = options.resetKey;
  const ensureIndex = options.ensureIndex ?? null;

  const [limit, setLimit] = useState(initial);

  useEffect(() => {
    setLimit(initial);
  }, [resetKey, initial]);

  useEffect(() => {
    if (ensureIndex == null || ensureIndex < 0) return;
    setLimit((prev) => Math.max(prev, ensureIndex + 1));
  }, [ensureIndex]);

  const visibleCount = Math.min(Math.max(limit, 0), Math.max(total, 0));
  const hasMore = visibleCount < total;
  const remaining = Math.max(0, total - visibleCount);
  const nextBatch = Math.min(step, remaining);

  const loadMore = () => setLimit((prev) => prev + step);
  const loadAll = () => setLimit(total);

  return { visibleCount, hasMore, remaining, nextBatch, loadMore, loadAll };
}
